import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBhOm2o3KBC0l40q-Qj1JDUSy61DBl0occ",
  authDomain: "metron-app-62cf3.firebaseapp.com",
  projectId: "metron-app-62cf3",
  storageBucket: "metron-app-62cf3.firebasestorage.app",
  messagingSenderId: "926345730922",
  appId: "1:926345730922:web:642a038334160475d66313"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
setPersistence(auth, browserLocalPersistence);
export default app;